// This optional code is used to register a service worker.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const PUBLIC_URL = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '';
    const publicUrl = new URL(PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service worker.'
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

// A new worker taking control means the precached app shell changed underneath
// us — the page on screen is still rendering the previous build, so reload once.
//
// Two guards. `refreshing` absorbs the duplicate controllerchange some browsers
// emit around skipWaiting. The controller check is read at registration time: no
// controller means this is a first install, where clientsClaim() fires
// controllerchange on a page that is already showing current code — reloading
// there would be a pointless flash, and on a broken SW an infinite loop.
let refreshing = false;
function reloadOnControllerChange() {
  if (!navigator.serviceWorker.controller) return;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

// DISCOVERY. Everything downstream of "a new worker exists" already works —
// SKIP_WAITING, controllerchange, reload. What was missing is anything that
// looks. The browser only re-fetches service-worker.js on a navigation, and
// this is an SPA: in-app route changes are not navigations. So a session that
// never reloads never learns a deploy happened — a counter iPad left open all
// day, or an installed PWA resumed from background, stays on the old build
// until the browser's own ~24h script check finally fires.
//
// Two triggers: tab becomes visible (covers wake-from-background, which is the
// common case) and an hourly timer (covers a tab that stays visible for a full
// shift). Background tabs throttle timers hard, which is fine — the
// visibilitychange handler catches those the moment anyone looks at them.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;
// Floor between any two checks. visibilitychange fires on every tab switch and
// update() costs a network fetch of the worker script each time.
const UPDATE_CHECK_MIN_GAP_MS = 60 * 1000;

let lastUpdateCheck = 0;
let updateChecksScheduled = false;
function scheduleUpdateChecks(registration) {
  if (updateChecksScheduled) return; // never stack a second interval/listener
  updateChecksScheduled = true;
  // Seeded, not zeroed: register() just fetched the script, so an immediate
  // tab-away-and-back should not refetch it.
  lastUpdateCheck = Date.now();

  const checkForUpdate = () => {
    const now = Date.now();
    if (now - lastUpdateCheck < UPDATE_CHECK_MIN_GAP_MS) return;
    lastUpdateCheck = now;
    // Rejects when offline or the script fetch fails. Neither is actionable,
    // and an unhandled rejection here would be console noise on every check
    // made on a flaky shop connection.
    registration.update().catch(() => {});
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate();
    }
  });
  setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      reloadOnControllerChange();
      scheduleUpdateChecks(registration);

      // A worker can ALREADY be installed and waiting when this page loads — a
      // previous visit installed it but never got it activated. onupdatefound
      // does not fire in that case (there is no `installing` worker), so without
      // this check nothing ever pokes the waiting worker and the device stays on
      // the old build through every future deploy. This is the dead end that
      // made deploys stop landing.
      if (registration.waiting && navigator.serviceWorker.controller) {
        if (config && config.onUpdate) {
          config.onUpdate(registration);
        }
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log(
                'New content is available and will be used when all tabs are closed.'
              );
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

